import React, {Component} from 'react';
import {FormGroup, FormControl, Col, Checkbox} from 'react-bootstrap';

export default class CheckboxField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			meta: {error, warning, touched, asyncValidating},
			onChangeHook,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "error") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>;
		}

		return (
			<FormGroup controlId={input.name} validationState={validationState} className={asyncValidating ? "loading" : ""}>
				<Col xs={12}>
					<Checkbox {...props} {...input} checked={input.value === true} onChange={(e) => {
						if (onChangeHook) {
							onChangeHook(!input.value)
						}
						input.onChange(e)
					}}><strong>{label}</strong></Checkbox>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/CheckboxField.js